import type { SignInExperienceResponse } from '@/types';

const toOrigin = (url: string): string | undefined => {
  if (!url) {
    return undefined;
  }

  try {
    return new URL(url).origin;
  } catch {
    return undefined;
  }
};

/**
 * The cowcamo website origin, used as the base URL for links that must point back to the main
 * cowcamo site rather than this auth host — the external password reset and the error-page
 * recovery link. Each of those appends its own path to this origin.
 *
 * The experience has no origin of its own to advertise, so it is derived from the per-environment
 * SIE `termsOfUseUrl` (fallback: `privacyPolicyUrl`), which cowcamo serves from the same site.
 */
export const getSiteOrigin = (
  experienceSettings: SignInExperienceResponse | undefined
): string | undefined =>
  // `?? ''` keeps an empty string from being passed on as a configured value.
  toOrigin(experienceSettings?.termsOfUseUrl ?? '') ??
  toOrigin(experienceSettings?.privacyPolicyUrl ?? '');
